import { Box, Button } from '@deckee/deck-hand';
import React, { FC, useCallback } from 'react';
import { ROUTE_SETTINGS } from '../../../../../services/route/route-names';
import { transitionToNextRoute } from '../../../../../services/route/route-navigation';
import { trackWeatherForecastSettingsClick } from '../../helpers/analytics/weatherForecastAnalytics';

const SettingsLink: FC = () => {
  const openSettings = useCallback(() => {
    trackWeatherForecastSettingsClick();
    transitionToNextRoute(ROUTE_SETTINGS);
  }, []);

  return (
    <Box mt={2} mb={4}>
      <Button
        outlined
        wide
        onClick={openSettings}
        data-testid="weather-forecast-settings-link"
      >
        Settings and preferences
      </Button>
    </Box>
  );
};

export default SettingsLink;
